import { createWebClient } from "@cd2/skeem-client"

declare global {
  interface Window {
    skeem: ReturnType<typeof createWebClient>
  }
}

type IQueryableField =
  | string
  | { attr: string }
  | { path: string[] }
  | { as: string; value: Record<string, unknown> }

export function buildSearchFilter(attributes: IQueryableField[], query: string) {
  if (!query.trim()) return { value: true }

  const words = query.trim().split(/\s+/)
  return {
    and: words.map(word => {
      const number = Number(word.match(/^£?([\d.,]+)$/)?.[1].replace(/,/g, ""))

      function condition(name: string, value: any) {
        return name.match(/pennies$/i)
          ? isNaN(number)
            ? { value: false }
            : { eq: [value, { value: Math.round(number * 100) }] }
          : { like: [value, { value: word }] }
      }

      return {
        or: attributes.map(attribute => {
          if (typeof attribute === "string") {
            return condition(attribute, { attr: attribute })
          } else if ("attr" in attribute) {
            return condition(attribute.attr, attribute)
          } else if ("path" in attribute) {
            const name = attribute.path[attribute.path.length - 1]
            return {
              anyIn: {
                attribute: attribute.path.slice(0, -1),
                query: condition(name, { attr: name }),
              },
            }
          } else {
            return condition(attribute.as, attribute.value)
          }
        }),
      }
    }),
  }
}
